import { getAdminOrgId } from "lib/site";
import Users from "screens/components/Users";

function AllUsers() {
  return <Users organisationId={getAdminOrgId()} editUserScreen="AllUsersEdit" displayOrganisationsFilter={true} />;
}

export default AllUsers;
